import { Helmet } from 'react-helmet';
import { Container, Row, Col } from 'react-bootstrap';

export const ContentNoLongerExists = () => {
	return (
		<Container className="py-11">
			<Helmet>
				<title>Hackett Connect - Content No Longer Exists</title>
			</Helmet>
			<Row>
				<Col>
					<h1 className="mb-3">Content No Longer Exists</h1>
					<p>
						Unfortunately, this page is no longer available. Please reach out to{' '}
						<a href="mailto:advisorysupport@poweredbyhackett.com">advisorysupport@poweredbyhackett.com</a>{' '}
						for further assistance.
					</p>
				</Col>
			</Row>
		</Container>
	);
};
